import CreatorCreateNewAlbumComponent from "./CreatorCreateNewAlbumComponent";
export default CreatorCreateNewAlbumComponent;
